import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.feature-sets.po-pdf-custom-field-display-view`

export default defineMessages({
  heading: {
    id: `${scope}.heading`,
    defaultMessage: 'PO PDF custom fields',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage:
      'Choose what custom fields to be included in PO PDF generation.',
  },
})
